module.exports = __webpack_public_path__ + "static/index/img/baikal-103.1055a253.jpg";